<template>
    <div class="home">
        <!-- <home-nav></home-nav> -->
        <home-post :postList="postList" :swiperList="swiperList" @like="like"></home-post>
        <!-- <home-bot></home-bot> -->
        <loading v-show="isLoading"></loading>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Loading from './Loading'
import HomeSwiper from '@/components/HomeSwiper.vue'
import HomeNav from '@/components/HomeNav.vue'
import HomePost from '@/components/HomePost.vue'
import HomeBot from '@/components/HomeBot.vue'

export default {
    name: 'Home',
    data() {
        return {
            postList:[],
            swiperList:[],
            newObj:{},
            appId:'',
            isLoading:false
        }
    },
    components: {
        Loading,
        HomeSwiper,
        HomeNav,
        HomePost,
        HomeBot
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo
        },
        // ...mapState([
        //     'isLoading'
        // ])
    },
    created() {

    },
    methods:{
        async getSwiperList() {
            let game_id = this.userInfo.game_id;
            let api = `/banner/get/${game_id}`;
            this.$http.get(api)
                .then((response) => {
                    this.isLoading = false;
                    let data = response.data;
                    this.swiperList = data;
                    this.$store.commit('setSwiperArray',data);
                })
                .catch((error) => {
                    this.$toast(error.response.data);
                })
        },
        async getPostList () {
            
        },
        async like(item) {
            item.is_liked = !item.is_liked;
            if(item.is_liked == true){
                item.like_count++;
            } else {
                item.like_count--;
            }
            let api = '/topic/like';
            let t = this;
            
            t.$http.post(api,{
                    topic_id: item.id,
                    app_user_id: this.userInfo.app_user_id
                })
                .then((res) => {
                    console.log('dianzan',res.data);
                    if(res.data == true) {
                        // this.$toast("点赞成功！")
                    }
                })
        }
    },
    created() {
        this.isLoading = true;
    },
    mounted() {
        // this.$store.commit('showLoading');
        this.getSwiperList();
    }
}
</script>

<style lang="stylus" scoped>
</style>
